import request from '@/utils/request'

const channel = {
  // 查询需求发送主表列表
  listNewIncome(query) {
    return request({
      url: '/cont/need/list',
      method: 'get',
      params: query,
      options: {
        loading: true
      }
    })
  },
  // 获取渠道收款记录详细信息
  getNewIncome(needId) {
    return request({
      url: '/cont/need/' + needId,
      method: 'get',
      options: {
        loading: true
      }
    })
  },
  // 删除新收款记录
  deleteNewIncome(needId) {
    return request({
      url: '/cont/need/' + needId,
      method: 'delete',
      options: {
        loading: true
      }
    })
  },
  // 查询记录数量
  newIncomeCount(query) {
    return request({
      url: '/cont/need/newIncomeCount',
      method: 'get',
      params: query
    })
  },
  // 查询汇总金额
  newIncomeSumMoney(query) {
    return request({
      url: '/cont/need/newIncomeSumMoney',
      method: 'get',
      params: query
    })
  },
  // // 获取需求发送详细信息
  // getNewIncome(needId) {
  //   return request({
  //     url: '/cont/need/' + needId,
  //     method: 'get'
  //   })
  // },
  // 根据收款获取合同列表
  newIncomeCont(data) {
    return request({
      url: '/cont/need/getContractIdList',
      method: 'post',
      data: data
    })
  },
  // 公海收款获取合同列表
  newWatersIncomeCont(data) {
    return request({
      url: '/cont/need/getWatersContractIdList',
      method: 'post',
      data: data
    })
  },
  // 收款类型
  getIncomeType(data) {
    return request({
      url: '/cont/need/getIncomeType',
      method: 'post',
      data: data
    })
  },
  // 人工识别到公海中,要传needId,incomeType
  addSea(data) {
    return request({
      url: '/cont/need/addSea',
      method: 'post',
      data: data
    })
  },

  // 查询需求发送分账明细列表
  listCapitalFlow(query) {
    return request({
      url: '/cont/needCapitalFlow/list',
      method: 'get',
      params: query
    })
  },
  // 根据一个money获取另一个 payMoney  rechargeMoney
  getPayMoney(query) {
    return request({
      url: '/cont/need/getPayMoney',
      method: 'get',
      params: query
    })
  },
  getChannelPayMoney(query) {
    return request({
      url: '/cont/need/getPayMoneyChannel',
      method: 'get',
      params: query
    })
  },
  getCustChannelPayMoney(data) {
    return request({
      url: '/cont/customeProint/getCustChannelPayMoney',
      method: 'post',
      data: data
    })
  },
  // 新收款记录认领明细列表
  listNewIncomeDetail(query) {
    return request({
      url: '/cont/needDetail/list',
      method: 'get',
      params: query
    })
  },
  // 获取新收款记录明细详细信息
  getNewIncomeDetail(needDetailId) {
    return request({
      url: '/cont/needDetail/' + needDetailId,
      method: 'get',
      options: {
        loading: true
      }
    })
  },
  // 新增认领 要传needId.三种情况：status=1 正常认领 status=2 公海认领 status=3 不是我的
  addNewIncomeDetail(data) {
    return request({
      url: '/cont/needDetail',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 修改新收款记录明细
  updateNewIncomeDetail(data) {
    return request({
      url: '/cont/needDetail',
      method: 'put',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 提出异议，要传needId
  noAgreeMatch(data) {
    return request({
      url: '/cont/needDetail/noAgreeMatch',
      method: 'post',
      data: data
    })
  },
  // 解除认领,要传needDetailId
  relieve(data) {
    return request({
      url: '/cont/needDetail/relieve',
      method: 'post',
      data: data
    })
  },
  // 重新发起(收款主表只有一个业务员不能有重新发起按钮),要传needDetailId
  reissue(data) {
    return request({
      url: '/cont/needDetail/reissue',
      method: 'post',
      data: data
    })
  },
  // 传needId 返回有数据则显示待确认列表，无数据待确认列表隐藏
  noConfirmedList(data) {
    return request({
      url: '/cont/needDetail/noConfirmedList',
      method: 'post',
      data: data
    })
  },
  // 获取收款消息发送详细信息
  getMsg(contNeedMsgId) {
    return request({
      url: '/cont/needMsg/' + contNeedMsgId,
      method: 'get',
      options: {
        loading: true
      }
    })
  },
  // 消息确认 传contNeedMsgId
  msgConfirm(data) {
    return request({
      url: '/cont/needDetail/msgConfirm',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 传needId 返回有数据“不是我的按钮”隐藏
  notMine(data) {
    return request({
      url: '/cont/needDetail/notMine',
      method: 'post',
      data: data
    })
  },

  // 充值列表 新收款记录认领明细列表(充值列表调用)
  mediaListNewIncomeDetail(query) {
    return request({
      url: '/cont/needDetail/mediaList',
      method: 'get',
      params: query,
      options: {
        loading: true
      }
    })
  },
  // 查询认领记录数量（按执行状态-媒介充值调用）：0、未执行[wzxCount];1、部门执行[bszxCount]；2、已执行[yzxCount];
  mediaGetCountItem(query) {
    return request({
      url: '/cont/needDetail/getCountItem',
      method: 'get',
      params: query
    })
  },

  // 查询收款渠道回款列表
  listChannelReturn(query) {
    return request({
      url: '/cont/channelReturn/list',
      method: 'get',
      params: query
    })
  },
  // 获取总金额
  listChannelReturnMoney(query) {
    return request({
      url: '/cont/channelReturn/listMoney',
      method: 'get',
      params: query
    })
  },
  // 获取数量
  getChannelReturnCount(query) {
    return request({
      url: '/cont/channelReturn/getContCount',
      method: 'get',
      params: query
    })
  },

  // 回款详情列表
  listChannelReturnDetail(query) {
    return request({
      url: '/cont/channelReturnDetail/list',
      method: 'get',
      params: query
    })
  },
  // 回款详情列表总金额
  listChannelReturnDetailMoney(query) {
    return request({
      url: '/cont/channelReturnDetail/listMoney',
      method: 'get',
      params: query
    })
  },

  // 查询非业务回款列表
  listIncomeType(query) {
    return request({
      url: '/cont/incomeType/list',
      method: 'get',
      params: query
    })
  },
  // 获取总金额
  listIncomeTypeMoney(query) {
    return request({
      url: '/cont/incomeType/listMoney',
      method: 'get',
      params: query
    })
  },
  // 获取数量
  getIncomeTypeCount(query) {
    return request({
      url: '/cont/incomeType/getContCount',
      method: 'get',
      params: query
    })
  },
  // 删除非业务回款数据
  deleteIncomeType(incomeTypeIds) {
    return request({
      url: '/cont/incomeType/' + incomeTypeIds,
      method: 'delete'
    })
  },

  // 新增财务收款审核
  addVerify(data) {
    return request({
      url: '/cont/verify',
      method: 'post',
      data: data
    })
  },

  // 查询账户可转余额和保证金
  mediaRefundFront(data) {
    return request({
      url: '/cont/contNewIncomeDetailExec/mediaRefundFront',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },

  // 退款（调拔）
  mediaRefund(data) {
    return request({
      url: '/cont/contNewIncomeDetailExec/mediaRefund',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },

  // 批量退款给客户
  batchRefund(data) {
    return request({
      url: '/cont/accountRefundVerify/batchRefund',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },

  // 分账列表接口
  listAccount(query) {
    return request({
      url: '/cda/account/list',
      method: 'get',
      params: query,
      options: {
        loading: true
      }
    })
  }
}

export default channel
